/*
 * @Description: 扩展vue的全局方法。
 */
const method = {}
method.install = Vue => {
  /**
   * @description: 国际化处理函数
   * @param str 国际化字符串
   * @param obj 国际化字符串变量
   * @return String 国际化之后的字符串
   */
  Vue.prototype._locale = function(str, obj = {}) {
    if (typeof str !== 'string' || !this.__proto__.$t) {
      return str
    }
    let mt = str.match(/\$t\[([^(\[\])]+)\]/g)
    if (Array.isArray(mt)) {
      mt.forEach(m => {
        let arr = m.match(/\$t\[([^(\[\])]+)\]/)
        str = str.replace(m, this.$t(arr[1], obj))
      })
    }
    return str
  }

  /**
   * @description: 将元素的高宽等像素单位的属性，数字转化为像素字符串
   * @param px 数字或者数字字符串，或者高宽单位（不变返回）。
   * @return: String
   */
  Vue.prototype.repairPx = function(px) {
    if (px && !isNaN(px)) {
      return px + 'px'
    }
    return px
  }
}

export default method



// WEBPACK FOOTER //
// ./src/components/SimbartUI/components/vue/method.js